import {
  useAppDispatch,
  useAppSelector,
} from '@/lib/client-hook/use-app-dispatch';
import { analytics } from '@/lib/firebase';
import {
  setCelebrities,
  useLazyFetchCelebritiesQuery,
} from '@/slice/celebrities';
import { logEvent } from '@firebase/analytics';
import { useSession } from 'next-auth/react';
import { useEffect, useRef } from 'react';

const useLogEvents = () => {
  const dispatch = useAppDispatch();
  const celebritiesKoreanName = useAppSelector(
    (state: any) => state.celebrities.celebritiesKoreanName,
  );
  const [trigger] = useLazyFetchCelebritiesQuery();

  const session = useSession();

  useEffect(() => {
    if (session.data?.user.userId && celebritiesKoreanName.length === 0) {
      trigger()
        .unwrap()
        .then(response => dispatch(setCelebrities(response)));
    }
  }, [session]);

  const logShareEvent = (eventKey: string, data: Record<string, any>) => {
    if (analytics) {
      logEvent(analytics, eventKey, {
        ...data,
        pick:
          celebritiesKoreanName.length > 0 ? celebritiesKoreanName : 'Guest',
      });
    }
  };

  return { logShareEvent };
};

export default useLogEvents;
